import { ReactSVG } from 'react-svg';
import Container from '../../components/Container';
import icons from '../../constants/icons';
import { Button, Text } from '../../components/SecondaryMarket';
import ProgressSavedFunctional from './index.function';
import { fontSizes } from '../../constants/constants';
import ViewReverse from '../../components/ViewReverse';

const ProgressSaved = () => {
  const { TextWeight, navigate, handleLogout, getContentKey } = ProgressSavedFunctional();

  return (
    <Container  handleLogout={handleLogout} title={getContentKey('new_account')} isBack={false}>
      <div className='bg-white shadow-light-shadow rounded-xl flex-1 px-6 py-10 flex flex-col items-center justify-center'>
        <div className='flex flex-col items-center justify-center w-full md:w-1/2 lg:w-1/3 xl:w-1/4'>
          <ReactSVG src={icons.success_check} />

          <Text
            text={getContentKey('progress_saved')}
            weight={TextWeight.headingRegular}
            size={fontSizes.h30}
            className={'text-dark-blue mt-6 mb-3'}
            align={'text-center'}
          />
          <Text text={getContentKey('application_saved_securly')} size={fontSizes.h14} align={'text-center'} />
          <Text text={getContentKey('complete_submit')} size={fontSizes.h14} align={'text-center'} />

          <ViewReverse className={'mt-5 gap-2 w-full'}>
            <Button text={getContentKey('signout')} className={'border-grey bg-transparent text-black w-full'}
              onClick={handleLogout}
            />
            <Button text={getContentKey('continue_editing')} className={'w-full'} onClick={() => navigate('/corporate-form?step=1')} />
          </ViewReverse>
        </div>
      </div>
    </Container>
  );
};

export default ProgressSaved;
